export default "__VITE_ASSET__DlDqWDwZ__"